import styled from "styled-components/macro";
import image1 from "../../Images/image1.png";

export const ImageBox = styled.div`
  background: url(${image1});
  background-size: cover;
  background-position-x: center;
  flex: 1;
  min-height: 20rem;
`;
export const TextContainer = styled.div`
  flex: 1;

  p {
    padding-right: 1.5rem;
    line-height: 1.9;
  }
`;

export const FlexCnt = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-row-gap: 2rem;
  overflow: hidden;
`;
